<template>
  <el-dialog :title="title" :visible="visible" @close="onClose">
    <el-form v-if="visible && targetMediaCore" label-position="right" label-width="150px">
      <el-form-item :label="dvrServerLabel">
        <dvr-servers-select
          v-model="idDvrServer"
          :id-media-core="targetMediaCore"
          :id-proxy-server="idProxyServer"
        />
      </el-form-item>
      <el-form-item :label="proxyServerLabel">
        <proxy-servers-select
          v-model="idProxyServer"
          :id-media-core="targetMediaCore"
          :id-dvr-server="idDvrServer"
        />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="onClose">Отменить</el-button>
      <el-button
        type="primary"
        :disabled="!idDvrServer || !idProxyServer"
        :loading="loading"
        @click="onSave"
      >
        Перенести
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { MEDIA_CORE, MEDIA_CORE_NAME } from "@/core/helpers/const";
import DvrServersSelect from "@/components/Server/feature/DvrServersSelect";
import ProxyServersSelect from "@/components/Server/feature/ProxyServersSelect";

export default {
  name: "MediaCoreMigrationDialog",
  components: {
    DvrServersSelect,
    ProxyServersSelect,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    idMediaCore: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      idDvrServer: null,
      idProxyServer: null,
    };
  },
  computed: {
    targetMediaCore() {
      if (this.idMediaCore === MEDIA_CORE.VK2) return MEDIA_CORE.VK3;
      if (this.idMediaCore === MEDIA_CORE.VK3) return MEDIA_CORE.VK2;
      return null;
    },
    title() {
      return `Миграция на ${MEDIA_CORE_NAME[this.targetMediaCore] || "другую платформу"}`;
    },
    dvrServerLabel() {
      return this.targetMediaCore === MEDIA_CORE.VK3 ? "ArchCore" : "DVR-сервер";
    },
    proxyServerLabel() {
      return this.targetMediaCore === MEDIA_CORE.VK3 ? "MCore" : "Прокси-сервер";
    },
  },
  watch: {
    visible(visible) {
      if (visible) {
        this.idDvrServer = null;
        this.idProxyServer = null;
      }
    },
  },
  methods: {
    onSave() {
      this.$emit("save", this.idDvrServer, this.idProxyServer);
    },
    onClose() {
      this.$emit("close");
    },
  },
};
</script>
